module.exports = __webpack_public_path__ + "static/screen-2b43e2befefed3ac3461b0eb13f08da3.jpg";